/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

// Dashboard components

// Dashboard example components

// @mui material components

import { getSubModulesByRoleId } from "../../store";

import Cookies from "universal-cookie";

// import AcceptedRejectionsW2 from "./REJSTW2/rejection-2";
// import AcceptedRejectionsW3 from "./REJSTW3/rejection-2";
// import REJSTW from "./REJSTW";
import RPTATW from "./RPTATW/index";
import RPTATW1 from "./RPTATW1/index";

const cookies = new Cookies();

const ReprintParent = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let showRPTATW1 = modulesData.find(
    (moduleId) => moduleId.moduleId == "4da51b8c-996d-4567-9709-2ba96884aceb",
  );

  // let showRPTATW1 =false

  // let showRPTATW = modulesData.find(
  //   (moduleId) => moduleId.moduleId == "30810d8c-f3e1-4edf-95a6-12234b215f47"
  // );

  let showRPTATW = true;

  return (
    <>
      {showRPTATW1 ? (
        <RPTATW1 />
      ) : showRPTATW ? (
        <RPTATW />
      ) : (
        <>
          <h4 style={{ textAlign: "center", marginTop: "6rem" }}>
            No Reprint Access
          </h4>
        </>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(ReprintParent);
